import { render, staticRenderFns } from "./efGroup.vue?vue&type=template&id=0a358ab7&lang=pug&"
import script from "./efGroup.vue?vue&type=script&lang=js&"
export * from "./efGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports